




















































































































import Vue from 'vue';
import { default as Component } from 'vue-class-component';

import IocContainer from '@/container/IocContainer';
import SERVICES from '@/container/Services';

import Format from '@/interfaces/Format';

const formatProvider = IocContainer.get<Format>(SERVICES.FORMAT);

@Component({
  props: {
    product: Object,
    isMobile: Boolean
  },
  filters: {
    date: formatProvider.date(),
    euro: formatProvider.euro(),
    euroFull: formatProvider.euroFull(),
    zip: formatProvider.zip()
  }
})
export default class HsgTariffDetailsInfoWidget extends Vue {
  protected displayDetails = true;
  private descriptionArrowClass = 'down';

  private displayDescriptionDetails() {
    this.displayDetails = !this.displayDetails;
    this.descriptionArrowClass = this.descriptionArrowClass === 'down' ? 'up' : 'down';
  }

  get hasBonus(): boolean {
    return (
      this.$props.product &&
      typeof this.$props.product.switchingBonus !== 'undefined' &&
      this.$props.product.switchingBonus > 0
    );
  }
}
